import { User } from 'app/projects/user/src/lib/models/user';
import { IExperienceAlumniWidgetContentQuery } from '../interfaces/experience-alumni-widget-content.interface';

// @dynamic
export class ExperienceAlumniWidgetContent {
    id: string;
    name: string;
    type: string;
    maxVisibleLength: number;
    content: User[];

    constructor(query?: IExperienceAlumniWidgetContentQuery) {
        if (query) {
            this.name = query.name;
            this.type = query.type;
            this.maxVisibleLength = query.max_visible_length;
            this.content = query.content.map((query) => new User(query));
        }
    }
}
